/* @flow */

export const userEditInterestsSectionId = 'interests';
